export var CmsEnv;
(function (CmsEnv) {
    CmsEnv["Qa"] = "qa";
    CmsEnv["Dev"] = "dev";
    CmsEnv["Prod"] = "prod";
    CmsEnv["Local"] = "local-dev";
    CmsEnv["Test"] = "test";
    CmsEnv["Mock"] = "mock";
})(CmsEnv || (CmsEnv = {}));
export var Sex;
(function (Sex) {
    Sex["Male"] = "m";
    Sex["Female"] = "f";
})(Sex || (Sex = {}));
export var VaccineDeliveryMethod;
(function (VaccineDeliveryMethod) {
    VaccineDeliveryMethod["Intramuscular"] = "\u0432\u043D\u0443\u0442\u0440\u0438\u043C\u044B\u0448\u0435\u0447\u043D\u044B\u0439";
    VaccineDeliveryMethod["Aerosol"] = "\u0430\u044D\u043E\u0440\u043E\u0437\u043E\u043B\u044C\u043D\u044B\u0439";
    VaccineDeliveryMethod["Oral"] = "\u043F\u0435\u0440\u043E\u0440\u0430\u043B\u044C\u043D\u044B\u0439";
    VaccineDeliveryMethod["Intradermal"] = "\u0432\u043D\u0443\u0442\u0440\u0438\u043A\u043E\u0436\u043D\u044B\u0439";
})(VaccineDeliveryMethod || (VaccineDeliveryMethod = {}));
export var InjectionSite;
(function (InjectionSite) {
    InjectionSite["Oral"] = "\u0447\u0435\u0440\u0435\u0437 \u0440\u043E\u0442";
    InjectionSite["Nasally"] = "\u0447\u0435\u0440\u0435\u0437 \u043D\u043E\u0441";
    InjectionSite["Shoulder"] = "\u043F\u043B\u0435\u0447\u043E";
    InjectionSite["hip"] = "\u0431\u0435\u0434\u0440\u043E";
})(InjectionSite || (InjectionSite = {}));
export var LaboratoryOrderSex;
(function (LaboratoryOrderSex) {
    LaboratoryOrderSex["Male"] = "Male";
    LaboratoryOrderSex["Female"] = "Female";
})(LaboratoryOrderSex || (LaboratoryOrderSex = {}));
export var ScheduleModelSubjectType;
(function (ScheduleModelSubjectType) {
    ScheduleModelSubjectType["User"] = "user";
    ScheduleModelSubjectType["Device"] = "device";
    ScheduleModelSubjectType["Office"] = "office";
})(ScheduleModelSubjectType || (ScheduleModelSubjectType = {}));
export var ScheduleModelStatus;
(function (ScheduleModelStatus) {
    ScheduleModelStatus["Active"] = "active";
    ScheduleModelStatus["Archived"] = "archive";
})(ScheduleModelStatus || (ScheduleModelStatus = {}));
export var SortingOrder;
(function (SortingOrder) {
    SortingOrder["Asc"] = "ASC";
    SortingOrder["Desc"] = "DESC";
})(SortingOrder || (SortingOrder = {}));
export const asc = SortingOrder.Asc;
export const desc = SortingOrder.Desc;
export var Channel;
(function (Channel) {
    Channel["Sms"] = "sms";
    Channel["Email"] = "email";
    /** топик нотификейшен */
    Channel["TgNotificationTopic"] = "tgChat";
    /** только топик нотификейшен без пересылания */
    Channel["TgNotificationTopicStrict"] = "tgNotification";
    /** чат-бот чайки */
    Channel["ChaikaTgBot"] = "tg";
    /** Для сайта надо, чтоб тегать врачей */
    Channel["TelegramName"] = "tgName";
    Channel["Viber"] = "vb";
    Channel["FaceBook"] = "fb";
    Channel["Skype"] = "skype";
    Channel["WhatsApp"] = "wa";
    Channel["Zoom"] = "zoom";
    Channel["ContactEmail"] = "contactEmail";
    Channel["CityPhone"] = "cityPhone";
    /** в пользователя */
    Channel["UserTg"] = "wp";
    /** в топик пользователя в практике практики */
    Channel["UserPracticeTopic"] = "wpg";
    /** в топик  практики */
    Channel["PracticeTopic"] = "pt";
    Channel["Default"] = "default";
})(Channel || (Channel = {}));
export var OnlineVisitChannel;
(function (OnlineVisitChannel) {
    OnlineVisitChannel["Phone"] = "\u0442\u0435\u043B\u0435\u0444\u043E\u043D";
    OnlineVisitChannel["Skype"] = "skype";
    OnlineVisitChannel["Zoom"] = "zoom";
})(OnlineVisitChannel || (OnlineVisitChannel = {}));
export var MessageStatus;
(function (MessageStatus) {
    MessageStatus["ReadyForSending"] = "ready for sending";
    MessageStatus["Dispatched"] = "dispatched";
    MessageStatus["Delivered"] = "delivered";
    MessageStatus["Failed"] = "failed";
    MessageStatus["PossibleSpam"] = "possible_spam";
    MessageStatus["Error"] = "error";
    MessageStatus["UndefinedChannel"] = "undefined channel";
    MessageStatus["DoNotNotify"] = "do not notify";
})(MessageStatus || (MessageStatus = {}));
export var MessageExternalStatus;
(function (MessageExternalStatus) {
    MessageExternalStatus["Queued"] = "queued";
    MessageExternalStatus["Processing"] = "processing";
    MessageExternalStatus["Accepted"] = "accepted";
    MessageExternalStatus["Delivered"] = "delivered";
    MessageExternalStatus["Failed"] = "failed";
    MessageExternalStatus["Unknown"] = "unknown";
    MessageExternalStatus["Expired"] = "expired";
    MessageExternalStatus["Cancelled"] = "cancelled";
})(MessageExternalStatus || (MessageExternalStatus = {}));
export var LaboratoryServiceOption;
(function (LaboratoryServiceOption) {
    LaboratoryServiceOption["Medication"] = "medication";
    LaboratoryServiceOption["Height"] = "height";
    LaboratoryServiceOption["Weight"] = "weight";
    LaboratoryServiceOption["Menstruation"] = "menstruation";
    LaboratoryServiceOption["Pregnancy"] = "pregnancy";
    LaboratoryServiceOption["Diuresis"] = "diuresis";
    LaboratoryServiceOption["Localization"] = "localization";
    LaboratoryServiceOption["NumberFragments"] = "numberFragments";
    LaboratoryServiceOption["CharacterPathologicalProcess"] = "characterPathologicalProcess";
    LaboratoryServiceOption["Comment"] = "comment";
    LaboratoryServiceOption["CollectionTime"] = "collectionTime";
})(LaboratoryServiceOption || (LaboratoryServiceOption = {}));
export var ServiceCategory;
(function (ServiceCategory) {
    ServiceCategory["Consultation"] = "consultation";
    ServiceCategory["Laboratory"] = "laboratory";
    ServiceCategory["Dentistry"] = "dentistry";
    ServiceCategory["Archive"] = "archive";
    ServiceCategory["Technical"] = "technical";
    ServiceCategory["Clinic"] = "clinic";
    ServiceCategory["Radiodiagnosis"] = "radiodiagnosis";
    ServiceCategory["UltrasoundDiagnostics"] = "ultrasoundDiagnostics";
    ServiceCategory["CheckUp"] = "checkUp";
    ServiceCategory["Hospital"] = "hospital";
    ServiceCategory["MaterialsAndPreparations"] = "materialsAndPreparations";
    ServiceCategory["OneCProduct"] = "1CProduct";
    ServiceCategory["Vaccination"] = "vaccination";
})(ServiceCategory || (ServiceCategory = {}));
export var OrderItemStatus;
(function (OrderItemStatus) {
    OrderItemStatus["InProgress"] = "in progress";
    OrderItemStatus["Failed"] = "failed";
    OrderItemStatus["Canceled"] = "canceled";
    OrderItemStatus["Done"] = "done";
})(OrderItemStatus || (OrderItemStatus = {}));
export var LaboratoryTestStatus;
(function (LaboratoryTestStatus) {
    LaboratoryTestStatus["InProgress"] = "in progress";
    LaboratoryTestStatus["Done"] = "done";
    LaboratoryTestStatus["Failed"] = "failed";
    LaboratoryTestStatus["Canceled"] = "canceled";
})(LaboratoryTestStatus || (LaboratoryTestStatus = {}));
export var EntryTypeType;
(function (EntryTypeType) {
    EntryTypeType["Consultation"] = "\u041A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044F";
    EntryTypeType["UsDiagnostics"] = "\u0423\u0417-\u0414\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430";
    EntryTypeType["Diagnostics"] = "\u0414\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430";
    EntryTypeType["Manipulation"] = "\u041C\u0430\u043D\u0438\u043F\u0443\u043B\u044F\u0446\u0438\u044F";
    EntryTypeType["Tests"] = "\u0410\u043D\u0430\u043B\u0438\u0437\u044B";
    EntryTypeType["System"] = "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F";
})(EntryTypeType || (EntryTypeType = {}));
export var ReferralStatus;
(function (ReferralStatus) {
    ReferralStatus["Active"] = "active";
    ReferralStatus["Cancelled"] = "cancelled";
    ReferralStatus["Expired"] = "expired";
    ReferralStatus["Executed"] = "executed";
})(ReferralStatus || (ReferralStatus = {}));
export var ReferralSorting;
(function (ReferralSorting) {
    ReferralSorting["BioCodes"] = "bio-codes";
    ReferralSorting["CreationTime"] = "creation-time";
    ReferralSorting["StartDate"] = "start-date";
})(ReferralSorting || (ReferralSorting = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Draft"] = "draft";
    OrderStatus["Canceled"] = "canceled";
    OrderStatus["Executed"] = "executed";
})(OrderStatus || (OrderStatus = {}));
export var FhirOrderDataStatus;
(function (FhirOrderDataStatus) {
    FhirOrderDataStatus["Completed"] = "completed";
    FhirOrderDataStatus["Failed"] = "failed";
    FhirOrderDataStatus["Loaded"] = "loaded";
    FhirOrderDataStatus["InProgress"] = "in-progress";
    FhirOrderDataStatus["WaitNextResult"] = "wait_next_result";
})(FhirOrderDataStatus || (FhirOrderDataStatus = {}));
export var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["Active"] = "active";
    ServiceStatus["Archived"] = "archived";
})(ServiceStatus || (ServiceStatus = {}));
export var PriceStatus;
(function (PriceStatus) {
    PriceStatus["Planned"] = "Planned";
    PriceStatus["Active"] = "active";
    PriceStatus["Archived"] = "archived";
})(PriceStatus || (PriceStatus = {}));
export var PriceType;
(function (PriceType) {
    PriceType["Base"] = "base";
    PriceType["Organization"] = "organization";
    PriceType["User"] = "user";
    PriceType["Contractor"] = "contractor";
    PriceType["Payer"] = "payer";
})(PriceType || (PriceType = {}));
export var InformedConsentStatus;
(function (InformedConsentStatus) {
    InformedConsentStatus["Signed"] = "signed";
    InformedConsentStatus["Draft"] = "draft";
})(InformedConsentStatus || (InformedConsentStatus = {}));
// Ehr
export var RepresentativeStatus;
(function (RepresentativeStatus) {
    RepresentativeStatus["Confirmed"] = "confirmed";
    RepresentativeStatus["NotConfirmed"] = "not-confirmed";
})(RepresentativeStatus || (RepresentativeStatus = {}));
export var RepresentativeType;
(function (RepresentativeType) {
    RepresentativeType["Child"] = "child";
    RepresentativeType["Trustee"] = "trustee";
    RepresentativeType["Other"] = "other";
})(RepresentativeType || (RepresentativeType = {}));
export var EhrStatus;
(function (EhrStatus) {
    EhrStatus["Active"] = "active";
    EhrStatus["Merged"] = "merged";
})(EhrStatus || (EhrStatus = {}));
// Ehr end
export var SpecialtyStatus;
(function (SpecialtyStatus) {
    SpecialtyStatus["Active"] = "active";
    SpecialtyStatus["Archived"] = "archived";
})(SpecialtyStatus || (SpecialtyStatus = {}));
export var AttachmentAction;
(function (AttachmentAction) {
    AttachmentAction["Create"] = "create";
    AttachmentAction["Truncate"] = "truncate";
    AttachmentAction["Update"] = "update";
    AttachmentAction["Unknown"] = "unknown";
})(AttachmentAction || (AttachmentAction = {}));
export var AttachmentStatus;
(function (AttachmentStatus) {
    AttachmentStatus["InProgress"] = "in progress";
    AttachmentStatus["Done"] = "done";
    AttachmentStatus["Failed"] = "failed";
    AttachmentStatus["Skipped"] = "skipped";
})(AttachmentStatus || (AttachmentStatus = {}));
export var PlanType;
(function (PlanType) {
    PlanType["Insurance"] = "insurance";
    PlanType["Organization"] = "organization";
    PlanType["Doctor"] = "doctor";
    /**
     * LEGACY (DV-193): функционал докторских подписок выпилен из кода. Значение оставлено ради
     * существующих строк plan.type='doctor subscription' — без него загрузка таких планов падает
     * (createComputationPolicy / getComparator по PlanType). Ретайр требует прод data-миграции.
     */
    PlanType["DoctorSubscription"] = "doctor subscription";
    PlanType["DoctorInsurance"] = "doctor insurance";
    PlanType["Patient"] = "patient";
    PlanType["GuarantyLetter"] = "guaranty letter";
    PlanType["WaitForGuarantyLetter"] = "wait for guaranty letter";
    PlanType["GuarantyLetterPlus"] = "guaranty letter plus";
    PlanType["Checkup"] = "checkup";
})(PlanType || (PlanType = {}));
export var PayerType;
(function (PayerType) {
    PayerType["Legal"] = "legal";
    PayerType["Individual"] = "individual";
})(PayerType || (PayerType = {}));
export var PlanStatus;
(function (PlanStatus) {
    PlanStatus["Active"] = "active";
    PlanStatus["Planned"] = "planned";
    PlanStatus["Archive"] = "archive";
})(PlanStatus || (PlanStatus = {}));
export var ContractStatus;
(function (ContractStatus) {
    ContractStatus["Active"] = "active";
    ContractStatus["Archive"] = "archive";
})(ContractStatus || (ContractStatus = {}));
export var EhrTypeOfWork;
(function (EhrTypeOfWork) {
    EhrTypeOfWork["Job"] = "job";
    EhrTypeOfWork["Study"] = "Study";
    EhrTypeOfWork["Other"] = "other";
})(EhrTypeOfWork || (EhrTypeOfWork = {}));
export var Recipient;
(function (Recipient) {
    Recipient["User"] = "user";
    Recipient["Patient"] = "patient";
})(Recipient || (Recipient = {}));
export var TemplateName;
(function (TemplateName) {
    TemplateName["ZoomMeetingLinks"] = "ZoomMeetingLinks";
    TemplateName["RequiredPaymentCard"] = "RequiredPaymentCard";
    TemplateName["CancellingWithPenalty"] = "CancellingWithPenalty";
})(TemplateName || (TemplateName = {}));
export var UserSortingField;
(function (UserSortingField) {
    UserSortingField["FirstName"] = "firstName";
    UserSortingField["LastName"] = "lastName";
})(UserSortingField || (UserSortingField = {}));
export var UserSearchField;
(function (UserSearchField) {
    UserSearchField["FullName"] = "fullName";
    UserSearchField["Email"] = "email";
})(UserSearchField || (UserSearchField = {}));
export var RenderedServiceSortingField;
(function (RenderedServiceSortingField) {
    RenderedServiceSortingField["EntryCreationTime"] = "entryCreationTime";
})(RenderedServiceSortingField || (RenderedServiceSortingField = {}));
export var RequirementType;
(function (RequirementType) {
    RequirementType["Device"] = "device";
    RequirementType["Doctor"] = "doctor";
    RequirementType["Office"] = "office";
})(RequirementType || (RequirementType = {}));
export var ConditionStatus;
(function (ConditionStatus) {
    ConditionStatus["Active"] = "active";
    ConditionStatus["Archived"] = "archived";
})(ConditionStatus || (ConditionStatus = {}));
export var DentalCondition;
(function (DentalCondition) {
    DentalCondition["Normal"] = "normal";
    DentalCondition["Problem"] = "problem";
    DentalCondition["Warning"] = "warning";
    DentalCondition["Treated"] = "treated";
    DentalCondition["Missing"] = "missing";
    DentalCondition["Implant"] = "implant";
    DentalCondition["ImplantProblem"] = "implantProblem";
})(DentalCondition || (DentalCondition = {}));
export var DentalTreatmentPlanStatus;
(function (DentalTreatmentPlanStatus) {
    DentalTreatmentPlanStatus["Active"] = "active";
    DentalTreatmentPlanStatus["Archived"] = "archive";
})(DentalTreatmentPlanStatus || (DentalTreatmentPlanStatus = {}));
export var DentalTreatmentStageStatus;
(function (DentalTreatmentStageStatus) {
    DentalTreatmentStageStatus["Planned"] = "planned";
    DentalTreatmentStageStatus["Performed"] = "performed";
})(DentalTreatmentStageStatus || (DentalTreatmentStageStatus = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["InsuranceCompany"] = "insuranceCompany";
    OrganizationType["Charity"] = "charity";
    OrganizationType["Assistance"] = "assistance";
    OrganizationType["Organization"] = "organization";
    OrganizationType["Clinic"] = "clinic";
    OrganizationType["ExternalClinic"] = "externalClinic";
    OrganizationType["Laboratory"] = "laboratory";
    OrganizationType["Contractor"] = "contractor";
})(OrganizationType || (OrganizationType = {}));
export var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["Active"] = "active";
    OrganizationStatus["Archived"] = "archived";
})(OrganizationStatus || (OrganizationStatus = {}));
export var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["Active"] = "active";
    DeviceStatus["Archived"] = "archived";
})(DeviceStatus || (DeviceStatus = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "active";
    UserStatus["Archived"] = "archived";
})(UserStatus || (UserStatus = {}));
export var EntryTypeFieldName;
(function (EntryTypeFieldName) {
    EntryTypeFieldName["NestedEntryType"] = "nestedEntryType";
    EntryTypeFieldName["PastMedicalHistoryEntryType"] = "pastMedicalHistoryEntryType";
    EntryTypeFieldName["MedicalIssuesEntryType"] = "medicalIssuesEntryType";
    EntryTypeFieldName["Legacy"] = "legacy";
    EntryTypeFieldName["Complains"] = "complains";
    EntryTypeFieldName["Pain"] = "pain";
    EntryTypeFieldName["MedicalHistory"] = "medical history";
    EntryTypeFieldName["Smoking"] = "smoking";
    EntryTypeFieldName["IsPregnant"] = "isPregnant";
    EntryTypeFieldName["MajorEvents"] = "major events";
    EntryTypeFieldName["MajorEventsNew"] = "field voSJ5";
    EntryTypeFieldName["SocialHistory"] = "social history";
    EntryTypeFieldName["SocialHistoryNew"] = "field Ac5Ny";
    EntryTypeFieldName["FamilyBackground"] = "family background";
    EntryTypeFieldName["FamilyBackgroundNew"] = "field u6wcA";
    EntryTypeFieldName["Conclusion"] = "conclusion";
    EntryTypeFieldName["AdditionalData"] = "additionalData";
    EntryTypeFieldName["Allergy"] = "allergy";
    EntryTypeFieldName["MedicalCases"] = "medicalCases";
    EntryTypeFieldName["DrugAllergy"] = "drugAllergy";
    EntryTypeFieldName["Drug"] = "drug";
    EntryTypeFieldName["NoseAndNasopharynx"] = "nose and nasopharynx";
    EntryTypeFieldName["OralCavity"] = "oral cavity";
    EntryTypeFieldName["RightEar"] = "right ear";
    EntryTypeFieldName["LeftEar"] = "left ear";
    EntryTypeFieldName["Larynx"] = "larynx";
    EntryTypeFieldName["LymphNodes"] = "lymph nodes";
    EntryTypeFieldName["AdditionalResearch"] = "additional research";
    EntryTypeFieldName["ObjectiveInspection"] = "objective inspection";
    EntryTypeFieldName["LastMenstrualPeriod"] = "lastMenstrualPeriod";
    EntryTypeFieldName["MenstrualFunction"] = "menstrualFunction";
    EntryTypeFieldName["LastPapTest"] = "lastPapTest";
    EntryTypeFieldName["AbnormalHistoryTest"] = "abnormalHistoryTest";
    EntryTypeFieldName["Pregnancy"] = "pregnancy";
    EntryTypeFieldName["GynecologistHistory"] = "gynecologistHistory";
    EntryTypeFieldName["SexualIntercourse"] = "sexualIntercourse";
    EntryTypeFieldName["Contraception"] = "contraception";
    EntryTypeFieldName["Height"] = "height";
    EntryTypeFieldName["Weigth"] = "weight";
    EntryTypeFieldName["BodyMassIndex"] = "bodyMassIndex";
    EntryTypeFieldName["BloodPressure"] = "bloodPressure";
    EntryTypeFieldName["Temperature"] = "temperature";
    EntryTypeFieldName["Pulse"] = "pulse";
    EntryTypeFieldName["RespiratoryRate"] = "respiratoryRate";
    EntryTypeFieldName["SO2"] = "SO2";
    EntryTypeFieldName["GenitaliaExterna"] = "genitaliaExterna";
    EntryTypeFieldName["Vagina"] = "vagina";
    EntryTypeFieldName["Cervix"] = "cervix";
    EntryTypeFieldName["Uterus"] = "uterus";
    EntryTypeFieldName["Epoophoron"] = "epoophoron";
    EntryTypeFieldName["InguinalLymphNodes"] = "inguinalLymphNodes";
    EntryTypeFieldName["MammaryGland"] = "mammaryGland";
    EntryTypeFieldName["ApproachType"] = "approachType";
    EntryTypeFieldName["MenstrualIrregularities"] = "menstrualIrregularities";
    EntryTypeFieldName["DayOfMenstrualCycle"] = "dayOfMenstrualCycle";
    EntryTypeFieldName["UterusPosition"] = "uterusPosition";
    EntryTypeFieldName["UterusShape"] = "uterusShape";
    EntryTypeFieldName["UterusLongitudinalSize"] = "uterusLongitudinalSize";
    EntryTypeFieldName["UterusThickness"] = "uterusThickness";
    EntryTypeFieldName["UterusTransverseSize"] = "uterusTransverseSize";
    EntryTypeFieldName["MyometriumEchostructure"] = "myometriumEchostructure";
    EntryTypeFieldName["MesenchymalTumor"] = "mesenchymalTumor";
    EntryTypeFieldName["UterineCavity"] = "uterineCavity";
    EntryTypeFieldName["EndometrialEcho"] = "endometrialEcho";
    EntryTypeFieldName["MenstrualPhase"] = "menstrualPhase";
    EntryTypeFieldName["CervixLength"] = "cervixLength";
    EntryTypeFieldName["CervixThickness"] = "cervixThickness";
    EntryTypeFieldName["CervixWidth"] = "cervixWidth";
    EntryTypeFieldName["CervixStructure"] = "cervixStructure";
    EntryTypeFieldName["Endocervix"] = "endocervix";
    EntryTypeFieldName["RightOvaryPosition"] = "rightOvaryPosition";
    EntryTypeFieldName["RightOvaryLength"] = "rightOvaryLength";
    EntryTypeFieldName["RightOvaryThickness"] = "rightOvaryThickness";
    EntryTypeFieldName["RightOvaryWidth"] = "rightOvaryWidth";
    EntryTypeFieldName["RightOvaryVolume"] = "rightOvaryVolume";
    EntryTypeFieldName["RightOvaryEchostructure"] = "rightOvaryEchostructure";
    EntryTypeFieldName["RightOvaryFollicle"] = "rightOvaryFollicle";
    EntryTypeFieldName["RightOvaryTumor"] = "rightOvaryTumor";
    EntryTypeFieldName["RightOvaryOviduct"] = "rightOvaryOviduct";
    EntryTypeFieldName["LeftOvaryPosition"] = "leftOvaryPosition";
    EntryTypeFieldName["LeftOvaryLength"] = "leftOvaryLength";
    EntryTypeFieldName["LeftOvaryThickness"] = "leftOvaryThickness";
    EntryTypeFieldName["LeftOvaryWidth"] = "leftOvaryWidth";
    EntryTypeFieldName["LeftOvaryVolume"] = "leftOvaryVolume";
    EntryTypeFieldName["LeftOvaryEchostructure"] = "leftOvaryEchostructure";
    EntryTypeFieldName["LeftOvaryFollicle"] = "leftOvaryFollicle";
    EntryTypeFieldName["LeftOvaryTumor"] = "leftOvaryTumor";
    EntryTypeFieldName["LeftOvaryOviduct"] = "leftOvaryOviduct";
    EntryTypeFieldName["PouchOfDouglasDescription"] = "pouchOfDouglasDescription";
    EntryTypeFieldName["Referrals"] = "referrals";
    EntryTypeFieldName["LaboratoryTests"] = "laboratoryTests";
    EntryTypeFieldName["PatientFileName"] = "patientFileName";
    EntryTypeFieldName["PatientFileComment"] = "patientFileComment";
    EntryTypeFieldName["DentalTreatment"] = "field owCAl";
    EntryTypeFieldName["Vaccine"] = "Vaccine";
    EntryTypeFieldName["VaccinationType"] = "field ENEW9";
    EntryTypeFieldName["VaccinationStage"] = "VaccinationStage";
    EntryTypeFieldName["LaboratoryTestResults"] = "laboratoryTestResults";
    EntryTypeFieldName["Weight"] = "weight";
    EntryTypeFieldName["RenderedService"] = "renderedService";
    EntryTypeFieldName["MaterialAct"] = "materialAct";
    EntryTypeFieldName["InsuranceCoordination"] = "field h9uJj";
    EntryTypeFieldName["SickLeave"] = "field iA4I9";
    EntryTypeFieldName["ChronicDiseases"] = "field DsDUR";
    EntryTypeFieldName["InstrumentalResearchData"] = "field E4ojN";
    EntryTypeFieldName["LaboratoryResearchData"] = "field RtqfO";
    EntryTypeFieldName["MedicalHistoryNew"] = "field 7IcK6";
    EntryTypeFieldName["EntryEpisodes"] = "entryEpisodes";
    EntryTypeFieldName["EpisdodesDiagnosis"] = "episdodesDiagnosis";
    EntryTypeFieldName["EpisdodesReferrals"] = "episdodesReferrals";
    EntryTypeFieldName["EpisdodesDrugs"] = "episdodesDrugs";
    EntryTypeFieldName["EpisdodesRecommendations"] = "episdodesRecommendations";
    EntryTypeFieldName["EpisdodesTasks"] = "episdodesTasks";
    EntryTypeFieldName["EpisdodesPlanDescription"] = "episdodesPlanDescription";
    EntryTypeFieldName["ConclusionText"] = "field w5ban";
    EntryTypeFieldName["UsedMedicationsLegacyFirst"] = "RegMeds";
    EntryTypeFieldName["UsedMedicationsLegacySecond"] = "field nw7ie";
    EntryTypeFieldName["Teeth"] = "field HkZkV";
})(EntryTypeFieldName || (EntryTypeFieldName = {}));
export var RenderedServiceStatus;
(function (RenderedServiceStatus) {
    RenderedServiceStatus["Unpaid"] = "unpaid";
    RenderedServiceStatus["Paid"] = "paid";
    RenderedServiceStatus["PaymentPending"] = "payment-pending";
    RenderedServiceStatus["Credited"] = "credited";
    RenderedServiceStatus["Refunded"] = "refunded";
    RenderedServiceStatus["Canceled"] = "canceled";
    RenderedServiceStatus["Deleted"] = "deleted";
})(RenderedServiceStatus || (RenderedServiceStatus = {}));
export var RenderedServiceType;
(function (RenderedServiceType) {
    RenderedServiceType["Service"] = "service";
    RenderedServiceType["Subscription"] = "subscription";
})(RenderedServiceType || (RenderedServiceType = {}));
export var AssistantType;
(function (AssistantType) {
    AssistantType["Main"] = "main";
    AssistantType["Temporary"] = "temporary";
})(AssistantType || (AssistantType = {}));
export var ReferralServiceType;
(function (ReferralServiceType) {
    ReferralServiceType["Simple"] = "simple";
    ReferralServiceType["Composite"] = "composite";
})(ReferralServiceType || (ReferralServiceType = {}));
export var EhrIdentityDocType;
(function (EhrIdentityDocType) {
    EhrIdentityDocType["RussianPassport"] = "russian-passport";
    EhrIdentityDocType["ForeignPassport"] = "foreign-passport";
})(EhrIdentityDocType || (EhrIdentityDocType = {}));
export var MedicalCaseStatus;
(function (MedicalCaseStatus) {
    MedicalCaseStatus["Open"] = "open";
    MedicalCaseStatus["Closed"] = "closed";
    /**
     * @deprecated Больше нельзя отправлять эпизоды в холд
     */
    MedicalCaseStatus["OnHold"] = "onHold";
})(MedicalCaseStatus || (MedicalCaseStatus = {}));
export var MedicalCaseTaskState;
(function (MedicalCaseTaskState) {
    MedicalCaseTaskState["Overdue"] = "overdue";
    MedicalCaseTaskState["Active"] = "active";
    MedicalCaseTaskState["WithoutActive"] = "withoutActive";
    MedicalCaseTaskState["NoActiveOrOverdue"] = "noActiveOrOverdue";
})(MedicalCaseTaskState || (MedicalCaseTaskState = {}));
export var ViewdType;
(function (ViewdType) {
    ViewdType["Referral"] = "referral";
})(ViewdType || (ViewdType = {}));
export var EntryTypeItemPresentationSubject;
(function (EntryTypeItemPresentationSubject) {
    EntryTypeItemPresentationSubject["User"] = "user";
    EntryTypeItemPresentationSubject["Entry"] = "entry";
})(EntryTypeItemPresentationSubject || (EntryTypeItemPresentationSubject = {}));
export var EntryTypeItemType;
(function (EntryTypeItemType) {
    EntryTypeItemType["Field"] = "field";
    EntryTypeItemType["Block"] = "block";
})(EntryTypeItemType || (EntryTypeItemType = {}));
export var ConditionsAgreement;
(function (ConditionsAgreement) {
    ConditionsAgreement["Without"] = "without";
    ConditionsAgreement["Required"] = "required";
    ConditionsAgreement["Excluded"] = "excluded";
})(ConditionsAgreement || (ConditionsAgreement = {}));
export var DictionaryItemStatus;
(function (DictionaryItemStatus) {
    DictionaryItemStatus["Active"] = "active";
    DictionaryItemStatus["Archived"] = "archived";
})(DictionaryItemStatus || (DictionaryItemStatus = {}));
export var RenderedServiceEventName;
(function (RenderedServiceEventName) {
    RenderedServiceEventName["RenderedServiceCanceled"] = "RenderedServiceCanceled";
    RenderedServiceEventName["RenderedServiceCreated"] = "RenderedServiceCreated";
    RenderedServiceEventName["RenderedServiceDeleted"] = "RenderedServiceDeleted";
    RenderedServiceEventName["RenderedServiceMedicalCaseAdded"] = "RenderedServiceMedicalCaseAdded";
    RenderedServiceEventName["RenderedServiceMedicalCaseRemoved"] = "RenderedServiceMedicalCaseRemoved";
    RenderedServiceEventName["RenderedServicePaymentChanged"] = "RenderedServicePaymentChanged";
    RenderedServiceEventName["RenderedServicePlanAdded"] = "RenderedServicePlanAdded";
    RenderedServiceEventName["RenderedServicePlanChanged"] = "RenderedServicePlanChanged";
    RenderedServiceEventName["RenderedServicePlanRemoved"] = "RenderedServicePlanRemoved";
    RenderedServiceEventName["RenderedServiceContractorUpdated"] = "RenderedServiceContractorUpdated";
    RenderedServiceEventName["RenderedServiceStatusChanged"] = "RenderedServiceStatusChanged";
    RenderedServiceEventName["RenderedServiceUpdated"] = "RenderedServiceUpdated";
})(RenderedServiceEventName || (RenderedServiceEventName = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "pending";
    PaymentStatus["Succeeded"] = "succeeded";
    PaymentStatus["WaitingForCapture"] = "waiting_for_capture";
    PaymentStatus["Error"] = "error";
    PaymentStatus["Canceled"] = "canceled";
    PaymentStatus["Refund"] = "refund";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["Cash"] = "cash";
    PaymentType["InternetAcquiring"] = "internet-acquiring";
    PaymentType["MerchantAcquiring"] = "merchant-acquiring";
    PaymentType["Yookassa"] = "yookassa";
    PaymentType["PersonalAccount"] = "personal-account";
    PaymentType["SetOffRefund"] = "set-off-refund";
})(PaymentType || (PaymentType = {}));
export var OperationStatus;
(function (OperationStatus) {
    OperationStatus["Preparing"] = "preparing";
    OperationStatus["Pending"] = "pending";
    OperationStatus["Done"] = "done";
    OperationStatus["Error"] = "error";
    OperationStatus["PreparingError"] = "preparing-error";
    OperationStatus["Fatal"] = "fatal";
})(OperationStatus || (OperationStatus = {}));
// Finance module start
export var OperationType;
(function (OperationType) {
    OperationType["Payment"] = "payment";
    OperationType["Refund"] = "refund";
    OperationType["AccountReplenishment"] = "account_replenishment";
    OperationType["RefundToAccount"] = "refund_to_account";
    OperationType["SubscriptionRefund"] = "refund_subscription";
    OperationType["WriteOff"] = "write_off";
    OperationType["Subscription"] = "subscription";
})(OperationType || (OperationType = {}));
export var FinancePaymentStatus;
(function (FinancePaymentStatus) {
    FinancePaymentStatus["Initialization"] = "initialization";
    FinancePaymentStatus["InitializationFailed"] = "initialization_failed";
    FinancePaymentStatus["Processing"] = "processing";
    FinancePaymentStatus["ProcessingFailed"] = "processing_failed";
    FinancePaymentStatus["WaitingForReceipt"] = "waiting_for_receipt";
    FinancePaymentStatus["ReceiptFailed"] = "receipt_failed";
    FinancePaymentStatus["Completed"] = "completed";
    FinancePaymentStatus["Canceled"] = "canceled";
})(FinancePaymentStatus || (FinancePaymentStatus = {}));
export var ExternalPaymentStatus;
(function (ExternalPaymentStatus) {
    ExternalPaymentStatus["Created"] = "Created";
    ExternalPaymentStatus["Pending"] = "Pending";
    ExternalPaymentStatus["Fulfilled"] = "Fulfilled";
    ExternalPaymentStatus["Refunded"] = "Refunded";
    ExternalPaymentStatus["Canceled"] = "Canceled";
    ExternalPaymentStatus["Failed"] = "Failed";
})(ExternalPaymentStatus || (ExternalPaymentStatus = {}));
export var ExternalRefundStatus;
(function (ExternalRefundStatus) {
    ExternalRefundStatus["Pending"] = "pending";
    ExternalRefundStatus["Succeeded"] = "succeeded";
    ExternalRefundStatus["Failed"] = "failed";
})(ExternalRefundStatus || (ExternalRefundStatus = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["RaiffeisenQrPlate"] = "raiffeisen_qr_plate";
    PaymentMethodType["RaiffeisenSbpLink"] = "raiffeisen_sbp_link";
    PaymentMethodType["RaiffeisenTerminal"] = "raiffeisen_terminal";
    PaymentMethodType["YookassaCard"] = "yookassa_card";
    PaymentMethodType["IDramLight"] = "idram_light";
    PaymentMethodType["TelcellLight"] = "telcell_light";
    PaymentMethodType["ArcaLink"] = "arca_link";
    PaymentMethodType["Transfer"] = "transfer";
    PaymentMethodType["Manual"] = "manual";
    PaymentMethodType["ManualWithoutReceipt"] = "manual_without_receipt";
    PaymentMethodType["MockTerminal"] = "mock_terminal";
    PaymentMethodType["MockCash"] = "mock_cash";
    PaymentMethodType["TBankLinkSplit"] = "tbank_link_split";
    // Legacy types
    PaymentMethodType["Cash"] = "cash";
    PaymentMethodType["InternetAcquiring"] = "internet-acquiring";
    PaymentMethodType["MerchantAcquiring"] = "merchant-acquiring";
    PaymentMethodType["Yookassa"] = "yookassa";
    PaymentMethodType["PersonalAccount"] = "personal-account";
    PaymentMethodType["SetOffRefund"] = "set-off-refund";
    PaymentMethodType["PaymentUrlTypeYooKassa"] = "payment-url-yookassa";
    PaymentMethodType["PaymentUrlTypeSBP"] = "payment-url-sbp";
    // Legacy types end
})(PaymentMethodType || (PaymentMethodType = {}));
export var RefundMethod;
(function (RefundMethod) {
    RefundMethod["Accounting"] = "accounting";
    RefundMethod["Manual"] = "manual";
})(RefundMethod || (RefundMethod = {}));
export var ReceiptProviderType;
(function (ReceiptProviderType) {
    ReceiptProviderType["OrangeData"] = "orange-data";
    ReceiptProviderType["Atol"] = "atol";
    ReceiptProviderType["PayX"] = "payx";
})(ReceiptProviderType || (ReceiptProviderType = {}));
export var FfdVersion;
(function (FfdVersion) {
    FfdVersion["FFD_105"] = "1.05";
    FfdVersion["FFD_12"] = "1.2";
})(FfdVersion || (FfdVersion = {}));
export var ReceiptStatus;
(function (ReceiptStatus) {
    ReceiptStatus["Pending"] = "pending";
    ReceiptStatus["Done"] = "done";
    ReceiptStatus["Error"] = "error";
    ReceiptStatus["Cancelled"] = "cancelled";
})(ReceiptStatus || (ReceiptStatus = {}));
export var ExternalReceiptStatus;
(function (ExternalReceiptStatus) {
    ExternalReceiptStatus["Completed"] = "completed";
    ExternalReceiptStatus["InProgress"] = "in-progress";
    ExternalReceiptStatus["Failed"] = "failed";
})(ExternalReceiptStatus || (ExternalReceiptStatus = {}));
export var PaymentEquipmentType;
(function (PaymentEquipmentType) {
    PaymentEquipmentType["Plate"] = "plate";
    PaymentEquipmentType["Terminal"] = "terminal";
})(PaymentEquipmentType || (PaymentEquipmentType = {}));
export var PaymentWorkplaceStatus;
(function (PaymentWorkplaceStatus) {
    PaymentWorkplaceStatus["Active"] = "active";
    PaymentWorkplaceStatus["Archived"] = "archived";
})(PaymentWorkplaceStatus || (PaymentWorkplaceStatus = {}));
// Finance module end
export var ServiceGroupStatus;
(function (ServiceGroupStatus) {
    ServiceGroupStatus["Active"] = "active";
    ServiceGroupStatus["Archive"] = "archive";
})(ServiceGroupStatus || (ServiceGroupStatus = {}));
export var ServiceGroupItemStatus;
(function (ServiceGroupItemStatus) {
    ServiceGroupItemStatus["Active"] = "active";
    ServiceGroupItemStatus["Archive"] = "archive";
    ServiceGroupItemStatus["Planned"] = "planned";
})(ServiceGroupItemStatus || (ServiceGroupItemStatus = {}));
export var CardStatus;
(function (CardStatus) {
    CardStatus["Active"] = "active";
    CardStatus["Archived"] = "archived";
})(CardStatus || (CardStatus = {}));
export var PrePaymentMethod;
(function (PrePaymentMethod) {
    PrePaymentMethod["ALL"] = "all";
    PrePaymentMethod["SBP"] = "sbp";
    PrePaymentMethod["RAIF_SBP"] = "raif_sbp";
    PrePaymentMethod["ARCA_LINK"] = "arca_link";
})(PrePaymentMethod || (PrePaymentMethod = {}));
export var LaboratoryStatus;
(function (LaboratoryStatus) {
    LaboratoryStatus["Active"] = "active";
    LaboratoryStatus["Archive"] = "archive";
})(LaboratoryStatus || (LaboratoryStatus = {}));
export var EntryStatus;
(function (EntryStatus) {
    EntryStatus["Signed"] = "signed";
    EntryStatus["Unsigned"] = "unsigned";
    EntryStatus["ReadyForDescribing"] = "readyForDescribing";
    EntryStatus["Draft"] = "draft";
    EntryStatus["Archive"] = "archive";
    EntryStatus["OnReview"] = "onReview";
    EntryStatus["ReviewCompleted"] = "reviewCompleted";
})(EntryStatus || (EntryStatus = {}));
export var EntryStatusCustom;
(function (EntryStatusCustom) {
    EntryStatusCustom["WithEds"] = "withEds";
    EntryStatusCustom["WithoutEds"] = "withoutEds";
})(EntryStatusCustom || (EntryStatusCustom = {}));
export var EntryTranslationStatus;
(function (EntryTranslationStatus) {
    EntryTranslationStatus["InProgress"] = "inProgress";
    EntryTranslationStatus["Confirmed"] = "confirmed";
})(EntryTranslationStatus || (EntryTranslationStatus = {}));
export var EntryAudioRecordStatus;
(function (EntryAudioRecordStatus) {
    /** Идёт диалоговая запись: сессия создана на init, принимаются chunk'и, finalize ещё не было. */
    EntryAudioRecordStatus["Recording"] = "recording";
    /** Запись создана, но ещё не отправлена на транскрипцию. */
    EntryAudioRecordStatus["New"] = "new";
    /** Отправлена/переотправлена на транскрипцию, поллер ждёт результат. */
    EntryAudioRecordStatus["TranscriptionInProgress"] = "in-progress";
    /** Клиентский промежуточный статус «загружено» (сейчас практически не используется). */
    EntryAudioRecordStatus["Uploaded"] = "uploaded";
    /** Результат получен: текст/диалог готов. */
    EntryAudioRecordStatus["Transcribed"] = "transcribed";
    /** Врач принял результат — терминальное состояние. */
    EntryAudioRecordStatus["Finished"] = "finished";
    /** Ошибка или таймаут транскрипции. */
    EntryAudioRecordStatus["Error"] = "error";
    /** Диалоговая сессия отменена врачом (удаление/закрытие вкладки) — терминальное состояние, reaper её не трогает. */
    EntryAudioRecordStatus["Cancelled"] = "cancelled";
})(EntryAudioRecordStatus || (EntryAudioRecordStatus = {}));
/**
 * Шаг обработки внутри статусов New и TranscriptionInProgress: расшифровка диалога и его
 * структурирование — это два последовательных запроса к сервису транскрипции, и оба держат
 * запись в одном статусе.
 */
export var EntryAudioRecordProcessingStage;
(function (EntryAudioRecordProcessingStage) {
    /** Запись создана, аудио сервисом транскрипции ещё не принято. */
    EntryAudioRecordProcessingStage["Submitting"] = "submitting";
    /** Первый запрос: аудио ушло на расшифровку. */
    EntryAudioRecordProcessingStage["Transcribing"] = "transcribing";
    /** Второй запрос: расшифрованный диалог ушёл на структурирование. */
    EntryAudioRecordProcessingStage["Structuring"] = "structuring";
})(EntryAudioRecordProcessingStage || (EntryAudioRecordProcessingStage = {}));
export var CreateOrdersStatus;
(function (CreateOrdersStatus) {
    /** Обработка ещё не запускалась — фронт не показывает статус. */
    CreateOrdersStatus["Hidden"] = "hidden";
    /** Идёт генерация плана и создание назначений. */
    CreateOrdersStatus["Processing"] = "processing";
    /** Все назначения созданы. */
    CreateOrdersStatus["Success"] = "success";
    /** Часть назначений создать не удалось. */
    CreateOrdersStatus["Partial"] = "partial";
    /** Не удалось создать назначения (или не удалось расшифровать). */
    CreateOrdersStatus["Error"] = "error";
})(CreateOrdersStatus || (CreateOrdersStatus = {}));
export var PlanOrderField;
(function (PlanOrderField) {
    PlanOrderField["Referral"] = "referral";
    PlanOrderField["Recommendation"] = "recommendation";
    PlanOrderField["Drug"] = "drug";
    PlanOrderField["Task"] = "task";
})(PlanOrderField || (PlanOrderField = {}));
export var EntryReviewStatus;
(function (EntryReviewStatus) {
    EntryReviewStatus["New"] = "new";
    EntryReviewStatus["InProgress"] = "in-progress";
    EntryReviewStatus["Completed"] = "completed";
    EntryReviewStatus["Error"] = "error";
})(EntryReviewStatus || (EntryReviewStatus = {}));
export var EntryReviewLifecycleStatus;
(function (EntryReviewLifecycleStatus) {
    EntryReviewLifecycleStatus["ReviewNeeded"] = "reviewNeeded";
    EntryReviewLifecycleStatus["RepeatReviewNeeded"] = "repeatReviewNeeded";
    EntryReviewLifecycleStatus["InProgress"] = "inProgress";
    EntryReviewLifecycleStatus["Completed"] = "completed";
})(EntryReviewLifecycleStatus || (EntryReviewLifecycleStatus = {}));
export var EntryReviewTargetType;
(function (EntryReviewTargetType) {
    EntryReviewTargetType["Entry"] = "entry";
    EntryReviewTargetType["Episode"] = "episode";
})(EntryReviewTargetType || (EntryReviewTargetType = {}));
export var LegalEntityType;
(function (LegalEntityType) {
    LegalEntityType["InsuranceCompany"] = "insuranceCompany";
    LegalEntityType["Charity"] = "charity";
    LegalEntityType["Assistance"] = "assistance";
    LegalEntityType["Organization"] = "organization";
    LegalEntityType["Clinic"] = "clinic";
    LegalEntityType["ExternalClinic"] = "externalClinic";
    LegalEntityType["Laboratory"] = "laboratory";
    LegalEntityType["Contractor"] = "contractor";
})(LegalEntityType || (LegalEntityType = {}));
export var LegalEntityStatus;
(function (LegalEntityStatus) {
    LegalEntityStatus["Active"] = "active";
    LegalEntityStatus["Archived"] = "archived";
})(LegalEntityStatus || (LegalEntityStatus = {}));
export var LegalEntityQueryField;
(function (LegalEntityQueryField) {
    LegalEntityQueryField["Name"] = "name";
    LegalEntityQueryField["Abbreviation"] = "abbreviation";
})(LegalEntityQueryField || (LegalEntityQueryField = {}));
export var OrganizationQueryField;
(function (OrganizationQueryField) {
    OrganizationQueryField["Name"] = "name";
    OrganizationQueryField["Abbreviation"] = "abbreviation";
})(OrganizationQueryField || (OrganizationQueryField = {}));
export var ClinicalNoteStatus;
(function (ClinicalNoteStatus) {
    ClinicalNoteStatus["Signed"] = "signed";
    ClinicalNoteStatus["Draft"] = "draft";
})(ClinicalNoteStatus || (ClinicalNoteStatus = {}));
export var EpisodeShortStatus;
(function (EpisodeShortStatus) {
    EpisodeShortStatus["PLANNED"] = "PLANNED";
    EpisodeShortStatus["WAITLIST"] = "WAITLIST";
    EpisodeShortStatus["ACTIVE"] = "ACTIVE";
    EpisodeShortStatus["ONHOLD"] = "ONHOLD";
    EpisodeShortStatus["FINISHED"] = "FINISHED";
    EpisodeShortStatus["CANCELLED"] = "CANCELLED";
    EpisodeShortStatus["ENTERED_IN_ERROR"] = "ENTERED_IN_ERROR";
})(EpisodeShortStatus || (EpisodeShortStatus = {}));
export var IndividualReportType;
(function (IndividualReportType) {
    IndividualReportType["Entry"] = "entry";
    IndividualReportType["PaymentAct"] = "paymentAct";
    IndividualReportType["PatientReservations"] = "patientReservations";
})(IndividualReportType || (IndividualReportType = {}));
export var PaymentService;
(function (PaymentService) {
    let PaymentProvider;
    (function (PaymentProvider) {
        PaymentProvider["Yookassa"] = "Yookassa";
        PaymentProvider["Raiffeisen"] = "Raiffeisen";
        PaymentProvider["Arca"] = "Arca";
        PaymentProvider["TBank"] = "TBank";
    })(PaymentProvider = PaymentService.PaymentProvider || (PaymentService.PaymentProvider = {}));
    let PaymentMethod;
    (function (PaymentMethod) {
        PaymentMethod["Card"] = "Card";
        PaymentMethod["FPS"] = "FPS";
        PaymentMethod["Link"] = "Link";
        PaymentMethod["QR"] = "QR";
        PaymentMethod["Terminal"] = "Terminal";
    })(PaymentMethod = PaymentService.PaymentMethod || (PaymentService.PaymentMethod = {}));
    let PaymentStatus;
    (function (PaymentStatus) {
        PaymentStatus["Created"] = "Created";
        PaymentStatus["Pending"] = "Pending";
        PaymentStatus["Fulfilled"] = "Fulfilled";
        PaymentStatus["Refunded"] = "Refunded";
        PaymentStatus["Canceled"] = "Canceled";
        PaymentStatus["Failed"] = "Failed";
    })(PaymentStatus = PaymentService.PaymentStatus || (PaymentService.PaymentStatus = {}));
    let Currency;
    (function (Currency) {
        Currency["RUB"] = "RUB";
        Currency["USD"] = "USD";
        Currency["EUR"] = "EUR";
        Currency["GEL"] = "GEL";
    })(Currency = PaymentService.Currency || (PaymentService.Currency = {}));
    let SlipType;
    (function (SlipType) {
        SlipType["Sell"] = "sell";
        SlipType["Buy"] = "buy";
        SlipType["SellReturn"] = "sellReturn";
        SlipType["BuyReturn"] = "buyReturn";
    })(SlipType = PaymentService.SlipType || (PaymentService.SlipType = {}));
    let PaymentType;
    (function (PaymentType) {
        PaymentType["Cash"] = "cash";
        PaymentType["Cashless"] = "electronically";
        PaymentType["Prepaid"] = "prepaid";
        PaymentType["Credit"] = "credit";
        PaymentType["Other"] = "other";
    })(PaymentType = PaymentService.PaymentType || (PaymentService.PaymentType = {}));
    let PaymentMethodType;
    (function (PaymentMethodType) {
        PaymentMethodType["FullPrepayment"] = "fullPrepayment";
        PaymentMethodType["Prepayment"] = "prepayment";
        PaymentMethodType["Advance"] = "advance";
        PaymentMethodType["FullPayment"] = "fullPayment";
        PaymentMethodType["PartialPayment"] = "partialPayment";
        PaymentMethodType["Credit"] = "credit";
        PaymentMethodType["CreditPayment"] = "creditPayment";
    })(PaymentMethodType = PaymentService.PaymentMethodType || (PaymentService.PaymentMethodType = {}));
    let ReceiptProvider;
    (function (ReceiptProvider) {
        ReceiptProvider["OrangeData"] = "orange-data";
        ReceiptProvider["Atol"] = "atol";
        ReceiptProvider["PayX"] = "payx";
    })(ReceiptProvider = PaymentService.ReceiptProvider || (PaymentService.ReceiptProvider = {}));
})(PaymentService || (PaymentService = {}));
export var TaxType;
(function (TaxType) {
    TaxType["None"] = "none";
    TaxType["Vat0"] = "vat0";
    TaxType["Vat10"] = "vat10";
    TaxType["Vat110"] = "vat110";
    TaxType["Vat20"] = "vat20";
    TaxType["Vat22"] = "vat22";
    TaxType["Vat120"] = "vat120";
})(TaxType || (TaxType = {}));
export var PositionType;
(function (PositionType) {
    PositionType["Commodity"] = "commodity";
    PositionType["Excise"] = "excise";
    PositionType["Job"] = "job";
    PositionType["Service"] = "service";
    PositionType["GamblingBet"] = "gamblingBet";
    PositionType["GamblingPrize"] = "gamblingPrize";
    PositionType["Lottery"] = "lottery";
    PositionType["LotteryPrize"] = "lotteryPrize";
    PositionType["IntellectualActivity"] = "intellectualActivity";
    PositionType["Payment"] = "payment";
    PositionType["AgentCommission"] = "agentCommission";
    PositionType["Pay"] = "pay";
    PositionType["Another"] = "another";
    PositionType["ProprietaryLaw"] = "proprietaryLaw";
    PositionType["NonOperatingIncome"] = "nonOperatingIncome";
    PositionType["InsuranceContributions"] = "insuranceContributions";
    PositionType["MerchantTax"] = "merchantTax";
    PositionType["ResortFee"] = "resortFee";
    PositionType["Deposit"] = "deposit";
})(PositionType || (PositionType = {}));
export var AgentType;
(function (AgentType) {
    AgentType["BankPayingAgent"] = "bankPayingAgent";
    AgentType["BankPayingSubagent"] = "bankPayingSubagent";
    AgentType["PayingAgent"] = "payingAgent";
    AgentType["PayingSubagent"] = "payingSubagent";
    AgentType["Attorney"] = "attorney";
    AgentType["CommissionAgent"] = "commissionAgent";
    AgentType["Another"] = "another";
})(AgentType || (AgentType = {}));
export var DiagnosisType;
(function (DiagnosisType) {
    DiagnosisType["Acute"] = "acute";
    DiagnosisType["Chronic"] = "chronic";
    DiagnosisType["Preventative"] = "preventative";
})(DiagnosisType || (DiagnosisType = {}));
export var FieldStatus;
(function (FieldStatus) {
    FieldStatus["Active"] = "active";
    FieldStatus["Deleted"] = "deleted";
})(FieldStatus || (FieldStatus = {}));
export var DrugStatus;
(function (DrugStatus) {
    DrugStatus["Active"] = "active";
    DrugStatus["Cancelled"] = "cancelled";
    DrugStatus["CancelledAppointment"] = "cancelledAppointment";
    DrugStatus["CanceledByPatient"] = "cancelledByPatient";
})(DrugStatus || (DrugStatus = {}));
export var MedicationStatus;
(function (MedicationStatus) {
    MedicationStatus["Active"] = "active";
    MedicationStatus["Deleted"] = "deleted";
    MedicationStatus["CancelledAppointment"] = "cancelledAppointment";
    MedicationStatus["CanceledByPatient"] = "cancelledByPatient";
})(MedicationStatus || (MedicationStatus = {}));
export var EntryOrder;
(function (EntryOrder) {
    EntryOrder["CreationTime"] = "creationTime";
    EntryOrder["VisitTime"] = "visitTime";
    EntryOrder["Urgency"] = "isUrgent";
})(EntryOrder || (EntryOrder = {}));
export var TaskRepetitionPeriod;
(function (TaskRepetitionPeriod) {
    TaskRepetitionPeriod["Daily"] = "daily";
    TaskRepetitionPeriod["Weekly"] = "weekly";
    TaskRepetitionPeriod["Monthly"] = "monthly";
    TaskRepetitionPeriod["Yearly"] = "yearly";
})(TaskRepetitionPeriod || (TaskRepetitionPeriod = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["Requested"] = "requested";
    TaskStatus["Completed"] = "completed";
    TaskStatus["Cancelled"] = "cancelled";
})(TaskStatus || (TaskStatus = {}));
export var FhirTaskStatus;
(function (FhirTaskStatus) {
    FhirTaskStatus["Requested"] = "requested";
    FhirTaskStatus["Cancelled"] = "cancelled";
    FhirTaskStatus["Accepted"] = "accepted";
    FhirTaskStatus["Rejected"] = "rejected";
    FhirTaskStatus["Failed"] = "failed";
    FhirTaskStatus["Completed"] = "completed";
    FhirTaskStatus["Draft"] = "draft";
    FhirTaskStatus["Received"] = "received";
    FhirTaskStatus["Ready"] = "ready";
    FhirTaskStatus["InProgress"] = "in-progress";
    FhirTaskStatus["OnHold"] = "on-hold";
    FhirTaskStatus["EnteredInError"] = "entered-in-error";
    // Deviation from FHIR
    FhirTaskStatus["Started"] = "started";
    FhirTaskStatus["Expired"] = "expired";
})(FhirTaskStatus || (FhirTaskStatus = {}));
export var TaskUrgency;
(function (TaskUrgency) {
    TaskUrgency["Routine"] = "routine";
    TaskUrgency["Urgent"] = "urgent";
    TaskUrgency["Asap"] = "asap";
    TaskUrgency["Stat"] = "stat";
})(TaskUrgency || (TaskUrgency = {}));
export var EntryTypeStatus;
(function (EntryTypeStatus) {
    EntryTypeStatus["Active"] = "active";
    EntryTypeStatus["Draft"] = "draft";
    EntryTypeStatus["Archived"] = "archived";
})(EntryTypeStatus || (EntryTypeStatus = {}));
export var EntryTypeBlockStatus;
(function (EntryTypeBlockStatus) {
    EntryTypeBlockStatus["Active"] = "active";
    EntryTypeBlockStatus["Draft"] = "draft";
    EntryTypeBlockStatus["Archived"] = "archived";
})(EntryTypeBlockStatus || (EntryTypeBlockStatus = {}));
export var EntryTypeFieldType;
(function (EntryTypeFieldType) {
    EntryTypeFieldType["Text"] = "text";
    EntryTypeFieldType["String"] = "string";
    EntryTypeFieldType["Number"] = "number";
    EntryTypeFieldType["Link"] = "link";
    EntryTypeFieldType["Select"] = "select";
    EntryTypeFieldType["MultiSelect"] = "multiSelect";
    EntryTypeFieldType["TextList"] = "textList";
    EntryTypeFieldType["OptionalText"] = "optionalText";
    EntryTypeFieldType["Date"] = "date";
    EntryTypeFieldType["Toggle"] = "toggle";
    EntryTypeFieldType["Computed"] = "computed";
    EntryTypeFieldType["CustomComputed"] = "customComputed";
    EntryTypeFieldType["CheckboxList"] = "checkboxList";
    EntryTypeFieldType["CheckboxWithText"] = "checkboxWithText";
    EntryTypeFieldType["SelectionButtons"] = "selectionButtons";
    EntryTypeFieldType["Scale"] = "scale";
    EntryTypeFieldType["DrugAllergy"] = "drugAllergy";
    EntryTypeFieldType["Allergy"] = "allergy";
    EntryTypeFieldType["MedicalCases"] = "medicalCases";
    EntryTypeFieldType["Drug"] = "drug";
    EntryTypeFieldType["Pregnancy"] = "pregnancy";
    EntryTypeFieldType["Referrals"] = "referrals";
    EntryTypeFieldType["RenderedService"] = "renderedService";
    EntryTypeFieldType["MaterialAct"] = "materialAct";
    EntryTypeFieldType["Table"] = "table";
    EntryTypeFieldType["CheckboxWithTextList"] = "checkboxWithTextList";
    EntryTypeFieldType["LegacyData"] = "legacyData";
    EntryTypeFieldType["NestedEntryType"] = "nestedEntryType";
    EntryTypeFieldType["LaboratoryTests"] = "laboratoryTests";
    EntryTypeFieldType["DentalTreatment"] = "dentalTreatment";
    EntryTypeFieldType["EntryMedicalCases"] = "entryMedicalCases";
    EntryTypeFieldType["Vaccinations"] = "vaccinations";
    EntryTypeFieldType["UsedMedications"] = "usedMedications";
    EntryTypeFieldType["EntryEpisodes"] = "entryEpisodes";
    EntryTypeFieldType["EpisdodesDiagnosis"] = "episdodesDiagnosis";
    EntryTypeFieldType["EpisdodesReferrals"] = "episdodesReferrals";
    EntryTypeFieldType["EpisdodesDrugs"] = "episdodesDrugs";
    EntryTypeFieldType["EpisdodesRecommendations"] = "episdodesRecommendations";
    EntryTypeFieldType["EpisdodesTasks"] = "episdodesTasks";
    EntryTypeFieldType["EpisdodesPlanDescription"] = "episdodesPlanDescription";
})(EntryTypeFieldType || (EntryTypeFieldType = {}));
export var DateMode;
(function (DateMode) {
    DateMode["FutureOnly"] = "FutureOnly";
    DateMode["PastOnly"] = "PastOnly";
    DateMode["AnyDate"] = "AnyDate";
})(DateMode || (DateMode = {}));
export var TableFieldCellType;
(function (TableFieldCellType) {
    TableFieldCellType["Title"] = "title";
    TableFieldCellType["Input"] = "input";
    TableFieldCellType["String"] = "string";
    TableFieldCellType["MinValue"] = "minValue";
    TableFieldCellType["MaxValue"] = "maxValue";
    TableFieldCellType["Formula"] = "formula";
    TableFieldCellType["Checkbox"] = "checkbox";
    TableFieldCellType["Calculate"] = "Calculate";
    TableFieldCellType["Select"] = "select";
})(TableFieldCellType || (TableFieldCellType = {}));
export var FileEntityType;
(function (FileEntityType) {
    FileEntityType["Entry"] = "entry";
    FileEntityType["Ehr"] = "ehr";
    FileEntityType["LegalEntityIndividualReport"] = "legalEntityIndividualReport";
    FileEntityType["Organization"] = "organization";
})(FileEntityType || (FileEntityType = {}));
export var FileStatus;
(function (FileStatus) {
    FileStatus["Uploading"] = "uploading";
    FileStatus["Uploaded"] = "uploaded";
})(FileStatus || (FileStatus = {}));
export var PatientDocumentStatus;
(function (PatientDocumentStatus) {
    PatientDocumentStatus["Active"] = "active";
    PatientDocumentStatus["Archived"] = "archived";
})(PatientDocumentStatus || (PatientDocumentStatus = {}));
export var EntryFileCategory;
(function (EntryFileCategory) {
    EntryFileCategory["Laboratory"] = "laboratory";
    EntryFileCategory["Diagnostic"] = "diagnostic";
    EntryFileCategory["PrintForm"] = "printForm";
})(EntryFileCategory || (EntryFileCategory = {}));
export var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus["Active"] = "active";
    NetworkStatus["Archived"] = "archived";
})(NetworkStatus || (NetworkStatus = {}));
export var OfficeStatus;
(function (OfficeStatus) {
    OfficeStatus["Active"] = "active";
    OfficeStatus["Archived"] = "archived";
})(OfficeStatus || (OfficeStatus = {}));
export var DeviceTypeStatus;
(function (DeviceTypeStatus) {
    DeviceTypeStatus["Active"] = "active";
    DeviceTypeStatus["Archived"] = "archived";
})(DeviceTypeStatus || (DeviceTypeStatus = {}));
export var WorkListStatus;
(function (WorkListStatus) {
    WorkListStatus["Sent"] = "sent";
    WorkListStatus["Failed"] = "failed";
})(WorkListStatus || (WorkListStatus = {}));
export var Modality;
(function (Modality) {
    Modality["ComputedRadiography"] = "CR";
    Modality["ComputedTomography"] = "CT";
    Modality["MagneticResonance"] = "MR";
    Modality["Ultrasound"] = "US";
    Modality["RadiographicImaging"] = "RG";
    Modality["Other"] = "OT";
})(Modality || (Modality = {}));
export var OfficeTypeStatus;
(function (OfficeTypeStatus) {
    OfficeTypeStatus["Active"] = "active";
    OfficeTypeStatus["Archived"] = "archived";
})(OfficeTypeStatus || (OfficeTypeStatus = {}));
export var ScheduleOrderingField;
(function (ScheduleOrderingField) {
    ScheduleOrderingField["OFFICE"] = "office";
    ScheduleOrderingField["SPECIALTY"] = "specialty";
    ScheduleOrderingField["USER"] = "user";
    ScheduleOrderingField["DAY"] = "day";
})(ScheduleOrderingField || (ScheduleOrderingField = {}));
export var WorkTimeStatus;
(function (WorkTimeStatus) {
    WorkTimeStatus["Active"] = "active";
    WorkTimeStatus["Proposal"] = "proposal";
    WorkTimeStatus["Draft"] = "draft";
})(WorkTimeStatus || (WorkTimeStatus = {}));
export var ScheduleRuleShift;
(function (ScheduleRuleShift) {
    ScheduleRuleShift["Morning"] = "morning";
    ScheduleRuleShift["Evening"] = "evening";
})(ScheduleRuleShift || (ScheduleRuleShift = {}));
export var ScheduleRuleRole;
(function (ScheduleRuleRole) {
    ScheduleRuleRole["Doctor"] = "doctor";
    ScheduleRuleRole["Assistant"] = "assistant";
    ScheduleRuleRole["AdditionalDoctor"] = "additional_doctor";
})(ScheduleRuleRole || (ScheduleRuleRole = {}));
export var ScheduleRuleRecurrence;
(function (ScheduleRuleRecurrence) {
    ScheduleRuleRecurrence["Week"] = "week";
    ScheduleRuleRecurrence["Month"] = "month";
})(ScheduleRuleRecurrence || (ScheduleRuleRecurrence = {}));
export var Languages;
(function (Languages) {
    Languages["English"] = "English";
    Languages["Arab"] = "Arab";
    Languages["Chinese"] = "Chinese";
    Languages["German"] = "German";
    Languages["French"] = "French";
    Languages["Spanish"] = "Spanish";
    Languages["Portuguese"] = "Portuguese";
    Languages["Turkish"] = "Turkish";
    Languages["Russian"] = "Russian";
    Languages["Georgian"] = "Georgian";
    Languages["Azerbaijani"] = "Azerbaijani";
    Languages["Armenian"] = "Armenian";
    Languages["Belorussian"] = "Belorussian";
    Languages["Kazakh"] = "Kazakh";
    Languages["Kyrgyz"] = "Kyrgyz";
    Languages["Moldavian"] = "Moldavian";
    Languages["Tajik"] = "Tajik";
    Languages["Turkmen"] = "Turkmen";
    Languages["Uzbek"] = "Uzbek";
    Languages["Ukrainian"] = "Ukrainian";
    Languages["Hebrew"] = "Hebrew";
    Languages["Dutch"] = "Dutch";
})(Languages || (Languages = {}));
export var Country;
(function (Country) {
    Country["Russia"] = "Russia";
    Country["Georgia"] = "Georgia";
    Country["Armenia"] = "Armenia";
    Country["UAE"] = "UAE";
    Country["Portugal"] = "Portugal";
    Country["UnitedKingdom"] = "UnitedKingdom";
})(Country || (Country = {}));
export var MessageChannel;
(function (MessageChannel) {
    MessageChannel["Tg"] = "tg";
    MessageChannel["Vb"] = "vb";
    MessageChannel["Sms"] = "sms";
    MessageChannel["Email"] = "email";
    MessageChannel["Wa"] = "wa";
})(MessageChannel || (MessageChannel = {}));
export var ServiceTax;
(function (ServiceTax) {
    ServiceTax["20%"] = "20%";
    ServiceTax["22%"] = "22%";
    ServiceTax["18%"] = "18%";
    ServiceTax["10%"] = "10%";
    ServiceTax["20/120%"] = "20/120%";
    ServiceTax["10/110%"] = "10/110%";
    ServiceTax["0%"] = "0%";
    ServiceTax["without"] = "without";
})(ServiceTax || (ServiceTax = {}));
export var TechnicalStatus;
(function (TechnicalStatus) {
    TechnicalStatus["Active"] = "active";
    TechnicalStatus["Deleted"] = "deleted";
    TechnicalStatus["Archive"] = "archive";
})(TechnicalStatus || (TechnicalStatus = {}));
export var Restrictions;
(function (Restrictions) {
    Restrictions["Doctor"] = "doctor";
    Restrictions["Referral"] = "referral";
})(Restrictions || (Restrictions = {}));
export var DictionaryNames;
(function (DictionaryNames) {
    DictionaryNames["FoodAllergen"] = "foodAllergen";
    DictionaryNames["EnvironmentAllergen"] = "environmentAllergen";
    DictionaryNames["AllergyReaction"] = "allergyReaction";
    DictionaryNames["Mkb10"] = "mkb10";
    DictionaryNames["Drug"] = "drug";
    DictionaryNames["ElementDrug"] = "elementDrug";
    DictionaryNames["DrugTradeNames"] = "drugTradeNames";
    DictionaryNames["InjectionSite"] = "injectionSite";
    DictionaryNames["DeliveryMethod"] = "deliveryMethod";
    DictionaryNames["Pregnancy"] = "pregnancy";
    DictionaryNames["Expertiza"] = "Expertiza";
    DictionaryNames["TeethFormulaAdult"] = "teethFormulaAdult";
    DictionaryNames["EpisodeName"] = "episodeName";
    DictionaryNames["VaccinationReaction"] = "vaccinationReaction";
})(DictionaryNames || (DictionaryNames = {}));
export var Locale;
(function (Locale) {
    Locale["Ru"] = "ru";
    Locale["En"] = "en";
    Locale["Ge"] = "ge";
    Locale["Am"] = "am";
    Locale["Pt"] = "pt";
})(Locale || (Locale = {}));
export var YandexLocale;
(function (YandexLocale) {
    YandexLocale["Ru"] = "ru";
    YandexLocale["En"] = "en";
    YandexLocale["Ge"] = "ka";
    YandexLocale["Am"] = "hy";
    YandexLocale["Pt"] = "pt";
})(YandexLocale || (YandexLocale = {}));
export var CountryCode;
(function (CountryCode) {
    CountryCode["Ru"] = "RU";
    CountryCode["Am"] = "AM";
    CountryCode["Ge"] = "GE";
    CountryCode["Ae"] = "AE";
    CountryCode["Pt"] = "PT";
    CountryCode["Gb"] = "GB";
})(CountryCode || (CountryCode = {}));
export var FeatureName;
(function (FeatureName) {
    FeatureName["UseEntryReview"] = "useEntryReview";
    FeatureName["AsyncReceipts"] = "asyncReceipts";
    FeatureName["UseServiceCoverageStatus"] = "useServiceCoverageStatus";
    FeatureName["ServiceCoverageStatusTab"] = "serviceCoverageStatusTab";
    FeatureName["RealtimeDictation"] = "realtimeDictation";
    FeatureName["CdaGeneration"] = "cdaGeneration";
    FeatureName["PushFirstNotifications"] = "pushFirstNotifications";
    FeatureName["SplitPayment"] = "splitPayment";
    FeatureName["PatientAppInsteadOfTelegram"] = "patientAppInsteadOfTelegram";
})(FeatureName || (FeatureName = {}));
export var CdaDeliveryStatus;
(function (CdaDeliveryStatus) {
    CdaDeliveryStatus["Queued"] = "queued";
    CdaDeliveryStatus["Sent"] = "sent";
    CdaDeliveryStatus["Registered"] = "registered";
    CdaDeliveryStatus["Failed"] = "failed";
})(CdaDeliveryStatus || (CdaDeliveryStatus = {}));
export var LlmPromptName;
(function (LlmPromptName) {
    LlmPromptName["EntryReview"] = "entry_review";
    LlmPromptName["EpisodeReview"] = "episode_review";
})(LlmPromptName || (LlmPromptName = {}));
// Realtime transcription protocol values; message types live in chaika-frontend-types
export const REALTIME_TRANSCRIPTION_PATH = '/api/transcription/realtime';
export var RealtimeTranscriptionErrorCode;
(function (RealtimeTranscriptionErrorCode) {
    RealtimeTranscriptionErrorCode["ProviderConnectFailed"] = "provider-connect-failed";
    RealtimeTranscriptionErrorCode["ProviderStalled"] = "provider-stalled";
    RealtimeTranscriptionErrorCode["ProviderError"] = "provider-error";
    RealtimeTranscriptionErrorCode["Internal"] = "internal";
    RealtimeTranscriptionErrorCode["ServerShutdown"] = "server-shutdown";
    RealtimeTranscriptionErrorCode["SessionExpired"] = "session-expired";
    RealtimeTranscriptionErrorCode["IdleTimeout"] = "idle-timeout";
    RealtimeTranscriptionErrorCode["Capacity"] = "capacity";
    RealtimeTranscriptionErrorCode["ProtocolViolation"] = "protocol-violation";
})(RealtimeTranscriptionErrorCode || (RealtimeTranscriptionErrorCode = {}));
export var RealtimeTranscriptionCloseCode;
(function (RealtimeTranscriptionCloseCode) {
    RealtimeTranscriptionCloseCode[RealtimeTranscriptionCloseCode["ProviderConnectFailed"] = 4001] = "ProviderConnectFailed";
    RealtimeTranscriptionCloseCode[RealtimeTranscriptionCloseCode["ProviderStalled"] = 4002] = "ProviderStalled";
    RealtimeTranscriptionCloseCode[RealtimeTranscriptionCloseCode["ProviderError"] = 4003] = "ProviderError";
    RealtimeTranscriptionCloseCode[RealtimeTranscriptionCloseCode["Capacity"] = 4004] = "Capacity";
    RealtimeTranscriptionCloseCode[RealtimeTranscriptionCloseCode["ProtocolViolation"] = 4005] = "ProtocolViolation";
    RealtimeTranscriptionCloseCode[RealtimeTranscriptionCloseCode["SessionExpired"] = 4006] = "SessionExpired";
    RealtimeTranscriptionCloseCode[RealtimeTranscriptionCloseCode["Internal"] = 4008] = "Internal";
    RealtimeTranscriptionCloseCode[RealtimeTranscriptionCloseCode["IdleTimeout"] = 4009] = "IdleTimeout";
})(RealtimeTranscriptionCloseCode || (RealtimeTranscriptionCloseCode = {}));
export var Currency;
(function (Currency) {
    Currency["RUB"] = "RUB";
    Currency["AED"] = "AED";
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
    Currency["GEL"] = "GEL";
    Currency["AMD"] = "AMD";
    Currency["GBP"] = "GBP";
})(Currency || (Currency = {}));
export var FormulaType;
(function (FormulaType) {
    FormulaType["Permanent"] = "permanent";
    FormulaType["Baby"] = "baby";
})(FormulaType || (FormulaType = {}));
/** @deprecated formula types for native Dental Page*/
export var DentalFormulaType;
(function (DentalFormulaType) {
    DentalFormulaType["Permanent"] = "permanent";
    DentalFormulaType["Baby"] = "baby";
    DentalFormulaType["Mixed"] = "mixed";
    DentalFormulaType["MixedPermanent"] = "mixedPermanent";
    DentalFormulaType["MixedBaby"] = "mixedBaby";
})(DentalFormulaType || (DentalFormulaType = {}));
export var Severity;
(function (Severity) {
    Severity["Severe"] = "24484000";
    Severity["Moderate"] = "6736007";
    Severity["Mild"] = "255604002";
})(Severity || (Severity = {}));
export var ClinicalStatus;
(function (ClinicalStatus) {
    ClinicalStatus["Active"] = "ACTIVE";
    ClinicalStatus["Recurrence"] = "RECURRENCE";
    ClinicalStatus["Relapse"] = "RELAPSE";
    ClinicalStatus["Inactive"] = "INACTIVE";
    ClinicalStatus["Remission"] = "REMISSION";
    ClinicalStatus["Resolved"] = "RESOLVED";
})(ClinicalStatus || (ClinicalStatus = {}));
export var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["Unconfirmed"] = "UNCONFIRMED";
    VerificationStatus["Provisional"] = "PROVISIONAL";
    VerificationStatus["Differential"] = "DIFFERENTIAL";
    VerificationStatus["Confirmed"] = "CONFIRMED";
    VerificationStatus["Refuted"] = "REFUTED";
    VerificationStatus["EnteredInError"] = "ENTERED_IN_ERROR";
})(VerificationStatus || (VerificationStatus = {}));
export var SpatialZoneName;
(function (SpatialZoneName) {
    SpatialZoneName["Buccal"] = "buccal";
    SpatialZoneName["Distal"] = "distal";
    SpatialZoneName["Lingual"] = "lingual";
    SpatialZoneName["Mesial"] = "mesial";
    SpatialZoneName["Occlusal"] = "occlusal";
    SpatialZoneName["FourZone"] = "fourZone";
    SpatialZoneName["FiveZone"] = "fiveZone";
    SpatialZoneName["Root"] = "root";
    SpatialZoneName["AllLowerJaw"] = "allLowerJaw";
    SpatialZoneName["AllUpperJaw"] = "allUpperJaw";
})(SpatialZoneName || (SpatialZoneName = {}));
export var InformedConsentTemplateType;
(function (InformedConsentTemplateType) {
    InformedConsentTemplateType["Patient"] = "patient";
    InformedConsentTemplateType["Service"] = "service";
})(InformedConsentTemplateType || (InformedConsentTemplateType = {}));
export var LaboratoryIntegrationType;
(function (LaboratoryIntegrationType) {
    LaboratoryIntegrationType["NadiaLab"] = "nadia-lab";
    LaboratoryIntegrationType["AstraLab"] = "astra-lab";
})(LaboratoryIntegrationType || (LaboratoryIntegrationType = {}));
export var LaboratoryServiceServiceStatus;
(function (LaboratoryServiceServiceStatus) {
    LaboratoryServiceServiceStatus["Active"] = "active";
    LaboratoryServiceServiceStatus["Archived"] = "archived";
})(LaboratoryServiceServiceStatus || (LaboratoryServiceServiceStatus = {}));
// System module
export var ProfilerLogStatus;
(function (ProfilerLogStatus) {
    ProfilerLogStatus["Pending"] = "pending";
    ProfilerLogStatus["Success"] = "success";
    ProfilerLogStatus["Failed"] = "failed";
})(ProfilerLogStatus || (ProfilerLogStatus = {}));
export var UsageStatisticEntityType;
(function (UsageStatisticEntityType) {
    UsageStatisticEntityType["Speciality"] = "speciality";
})(UsageStatisticEntityType || (UsageStatisticEntityType = {}));
// System module end
// Replication
export var ReplicationEntity;
(function (ReplicationEntity) {
    ReplicationEntity["Entry"] = "entry";
    ReplicationEntity["EntrySnapshot"] = "entry_snapshot";
    ReplicationEntity["EventStore"] = "event_store";
    ReplicationEntity["FinancePayment"] = "finance.payment";
    ReplicationEntity["WorkTime"] = "work_time";
    ReplicationEntity["ScheduleWorkTime"] = "schedule_work_time";
    ReplicationEntity["ScheduleModel"] = "schedule_model";
    ReplicationEntity["MedicalCase"] = "medical_case";
    ReplicationEntity["Contract"] = "contract";
    ReplicationEntity["Ehr"] = "ehr";
    ReplicationEntity["LegalEntity"] = "legal_entity";
    ReplicationEntity["Referral"] = "referral";
    ReplicationEntity["ReferralEventStore"] = "referral_event_store";
    ReplicationEntity["RenderedServiceView"] = "rendered_service_view";
    ReplicationEntity["Reservation"] = "reservation";
    ReplicationEntity["ReservationEventStore"] = "reservation_event_store";
    ReplicationEntity["Subscription"] = "subscription";
    ReplicationEntity["Organization"] = "organization";
    ReplicationEntity["Plan"] = "plan";
    ReplicationEntity["Service"] = "service";
    ReplicationEntity["PersonalAccount"] = "finance.personal_account";
    ReplicationEntity["ReferralCompositeService"] = "referral_composite_service";
    ReplicationEntity["ReferralCompositeServicePlan"] = "referral_composite_service_plan";
    ReplicationEntity["ReferralLaboratoryService"] = "referral_laboratory_service";
    ReplicationEntity["Price"] = "price";
})(ReplicationEntity || (ReplicationEntity = {}));
export var ReplicationEntityWithoutTimeColumn;
(function (ReplicationEntityWithoutTimeColumn) {
    ReplicationEntityWithoutTimeColumn["Office"] = "office";
    ReplicationEntityWithoutTimeColumn["Users"] = "users";
    // Dictionary = 'dictionary',
    ReplicationEntityWithoutTimeColumn["Device"] = "device";
    ReplicationEntityWithoutTimeColumn["PaymentMethod"] = "finance.payment_method";
})(ReplicationEntityWithoutTimeColumn || (ReplicationEntityWithoutTimeColumn = {}));
// Insurance module
export var ProtestActStatus;
(function (ProtestActStatus) {
    ProtestActStatus["New"] = "new";
    ProtestActStatus["InProcess"] = "inProcess";
    ProtestActStatus["Finish"] = "finish";
    ProtestActStatus["Deleted"] = "deleted";
})(ProtestActStatus || (ProtestActStatus = {}));
export var ProtestActItemStatus;
(function (ProtestActItemStatus) {
    ProtestActItemStatus["New"] = "new";
    ProtestActItemStatus["InProcess"] = "inProcess";
    ProtestActItemStatus["Processed"] = "processed";
    ProtestActItemStatus["Finish"] = "finish";
})(ProtestActItemStatus || (ProtestActItemStatus = {}));
export var ProtestActItemCalculateDataStatus;
(function (ProtestActItemCalculateDataStatus) {
    ProtestActItemCalculateDataStatus["Ok"] = "ok";
    ProtestActItemCalculateDataStatus["Error"] = "error";
})(ProtestActItemCalculateDataStatus || (ProtestActItemCalculateDataStatus = {}));
// Insurance module end
export var ReplicationUpdateType;
(function (ReplicationUpdateType) {
    ReplicationUpdateType["InsertUpdate"] = "insertUpdate";
    ReplicationUpdateType["WithoutTimeColumn"] = "withoutTimeColumn";
    ReplicationUpdateType["SimpleIdUpdate"] = "simpleIdUpdate";
    ReplicationUpdateType["Update"] = "update";
})(ReplicationUpdateType || (ReplicationUpdateType = {}));
// Schedule
export var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["Reserved"] = "reserved";
    ReservationStatus["Cancelled"] = "cancelled";
    ReservationStatus["VisitOccurred"] = "visitOccurred";
})(ReservationStatus || (ReservationStatus = {}));
export var ReservationType;
(function (ReservationType) {
    ReservationType["Visit"] = "visit";
    ReservationType["OnlineVisit"] = "online visit";
    ReservationType["Draft"] = "draft";
    ReservationType["Lunch"] = "lunch";
    ReservationType["Vacation"] = "vacation";
    ReservationType["Disease"] = "disease";
    ReservationType["Meeting"] = "meeting";
    ReservationType["Training"] = "training";
    ReservationType["NotWorkTime"] = "not work time";
    ReservationType["Vaccination"] = "vaccination";
    ReservationType["Collection"] = "collection";
    ReservationType["WaitingList"] = "waiting list";
    ReservationType["Operation"] = "operation";
    ReservationType["Appointment"] = "appointment";
    ReservationType["OnlineAppointment"] = "online_appointment";
    ReservationType["TimeBlock"] = "time_block";
    ReservationType["RoomBooking"] = "room_booking";
})(ReservationType || (ReservationType = {}));
export var ReservationCancellingType;
(function (ReservationCancellingType) {
    ReservationCancellingType["Manually"] = "manually";
    ReservationCancellingType["AutomaticByPaymentCardAbsence"] = "automatic by payment card absence";
    ReservationCancellingType["Fined"] = "fined";
})(ReservationCancellingType || (ReservationCancellingType = {}));
export var ReservationSortingField;
(function (ReservationSortingField) {
    ReservationSortingField["StartTime"] = "startTime";
})(ReservationSortingField || (ReservationSortingField = {}));
export var ReservationEventType;
(function (ReservationEventType) {
    ReservationEventType["OnlineVisitUpdated"] = "OnlineVisitUpdated";
    ReservationEventType["VisitCancelled"] = "VisitCancelled";
    ReservationEventType["OfficeVisitUpdated"] = "OfficeVisitUpdated";
    ReservationEventType["OfficeVisitCreated"] = "OfficeVisitCreated";
    ReservationEventType["VisitReservationUpdated"] = "VisitReservationUpdated";
    ReservationEventType["ReservationStatusUpdated"] = "ReservationStatusUpdated";
    ReservationEventType["VisitReservationCreated"] = "VisitReservationCreated";
    ReservationEventType["OnlineVisitCreated"] = "OnlineVisitCreated";
    ReservationEventType["VisitReservationStatusUpdated"] = "VisitReservationStatusUpdated";
    ReservationEventType["VisitOccurred"] = "VisitOccurred";
})(ReservationEventType || (ReservationEventType = {}));
export var ScheduleStatisticEntityType;
(function (ScheduleStatisticEntityType) {
    ScheduleStatisticEntityType["Speciality"] = "speciality";
    ScheduleStatisticEntityType["Service"] = "service";
    ScheduleStatisticEntityType["Doctor"] = "doctor";
})(ScheduleStatisticEntityType || (ScheduleStatisticEntityType = {}));
export var PriceReportType;
(function (PriceReportType) {
    PriceReportType["Base"] = "base";
    PriceReportType["Individual"] = "individual";
})(PriceReportType || (PriceReportType = {}));
// Schedule end
export var SubscriptionOrderStatus;
(function (SubscriptionOrderStatus) {
    SubscriptionOrderStatus["Created"] = "created";
    SubscriptionOrderStatus["Paid"] = "paid";
    SubscriptionOrderStatus["Active"] = "active";
    SubscriptionOrderStatus["Canceled"] = "canceled";
    SubscriptionOrderStatus["Expired"] = "expired";
})(SubscriptionOrderStatus || (SubscriptionOrderStatus = {}));
export var AnnualProgramStatus;
(function (AnnualProgramStatus) {
    AnnualProgramStatus["Created"] = "created";
    AnnualProgramStatus["Paid"] = "paid";
    AnnualProgramStatus["Active"] = "active";
    AnnualProgramStatus["Canceled"] = "canceled";
    AnnualProgramStatus["Expired"] = "expired";
})(AnnualProgramStatus || (AnnualProgramStatus = {}));
export var AuditEventEntityType;
(function (AuditEventEntityType) {
    AuditEventEntityType["Service"] = "Service";
    AuditEventEntityType["Price"] = "Price";
    AuditEventEntityType["WorkTime"] = "WorkTime";
    AuditEventEntityType["Assistant"] = "Assistant";
    AuditEventEntityType["ScheduleModel"] = "ScheduleModel";
    AuditEventEntityType["Ehr"] = "Ehr";
    AuditEventEntityType["Entry"] = "Entry";
    AuditEventEntityType["Unknown"] = "Unknown";
    AuditEventEntityType["Plan"] = "Plan";
    AuditEventEntityType["Users"] = "Users";
})(AuditEventEntityType || (AuditEventEntityType = {}));
export var AuditEventType;
(function (AuditEventType) {
    AuditEventType["ServiceStatusUpdate"] = "ServiceStatusUpdate";
    AuditEventType["ServiceUpdate"] = "ServiceUpdate";
    AuditEventType["ServiceCreate"] = "ServiceCreate";
    AuditEventType["PriceCreated"] = "PriceCreated";
    AuditEventType["PriceArchived"] = "PriceArchived";
    AuditEventType["PriceUpdate"] = "PriceUpdate";
    AuditEventType["PriceStatusUpdate"] = "PriceStatusUpdate";
    AuditEventType["WorkTimeBulkUpdate"] = "WorkTimeBulkUpdate";
    AuditEventType["WorkTimeCreate"] = "WorkTimeCreate";
    AuditEventType["WorkTimeUpdate"] = "WorkTimeUpdate";
    AuditEventType["WorkTimeRemove"] = "WorkTimeRemove";
    AuditEventType["AssistantCreate"] = "AssistantCreate";
    AuditEventType["AssistantUpdate"] = "AssistantUpdate";
    AuditEventType["AssistantRemove"] = "AssistantRemove";
    AuditEventType["EhrFind"] = "EhrFind";
    AuditEventType["EhrCreated"] = "EhrCreated";
    AuditEventType["EhrUpdated"] = "EhrUpdated";
    AuditEventType["EhrViewed"] = "EhrViewed";
    AuditEventType["EntryViewed"] = "EntryViewed";
    AuditEventType["ScheduleModelCreated"] = "ScheduleModelCreated";
    AuditEventType["ScheduleModelUpdated"] = "ScheduleModelUpdated";
    AuditEventType["ScheduleModelStatusUpdated"] = "ScheduleModelStatusUpdated";
    AuditEventType["PlanUpdated"] = "PlanUpdated";
    AuditEventType["PlanCreated"] = "PlanCreated";
    AuditEventType["UsetCreated"] = "UsetCreated";
    AuditEventType["UsetUpdated"] = "UsetUpdated";
    AuditEventType["UsetStatusUpdate"] = "UsetStatusUpdate";
    AuditEventType["UsetRoleUpdate"] = "UsetRoleUpdate";
    AuditEventType["FeatureUpdated"] = "FeatureUpdated";
    AuditEventType["UpdateTranslation"] = "UpdateTranslation";
    AuditEventType["LlmPromptUpdated"] = "LlmPromptUpdated";
    AuditEventType["LlmPromptCreated"] = "LlmPromptCreated";
    AuditEventType["EhrAccessChecked"] = "EhrAccessChecked";
    AuditEventType["CrossCountryView"] = "CrossCountryView";
})(AuditEventType || (AuditEventType = {}));
export var EhrViewContext;
(function (EhrViewContext) {
    EhrViewContext["PatientPage"] = "patient-page";
    EhrViewContext["EntryPage"] = "entry-page";
})(EhrViewContext || (EhrViewContext = {}));
export var SubscriptionOrderChatLinkStatus;
(function (SubscriptionOrderChatLinkStatus) {
    SubscriptionOrderChatLinkStatus["Updating"] = "updating";
    SubscriptionOrderChatLinkStatus["Failed"] = "failed";
    SubscriptionOrderChatLinkStatus["Done"] = "done";
})(SubscriptionOrderChatLinkStatus || (SubscriptionOrderChatLinkStatus = {}));
export var SessionStorageKeys;
(function (SessionStorageKeys) {
    SessionStorageKeys["LastViewedEntries"] = "lastViewedEntries";
    SessionStorageKeys["FromAuthPage"] = "fromAuthPage";
})(SessionStorageKeys || (SessionStorageKeys = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["Flat"] = "flat";
    DiscountType["Average"] = "average";
    DiscountType["Hurdle"] = "hurdle";
})(DiscountType || (DiscountType = {}));
export var TaxDeductionEntityType;
(function (TaxDeductionEntityType) {
    TaxDeductionEntityType["Service"] = "service";
    TaxDeductionEntityType["Subscription"] = "subscription";
})(TaxDeductionEntityType || (TaxDeductionEntityType = {}));
export var OneCMaterialActStatus;
(function (OneCMaterialActStatus) {
    OneCMaterialActStatus["Pending"] = "pending";
    OneCMaterialActStatus["Sending"] = "sending";
    OneCMaterialActStatus["Succeeded"] = "succeeded";
    OneCMaterialActStatus["Error"] = "error";
    OneCMaterialActStatus["Canceled"] = "canceled";
})(OneCMaterialActStatus || (OneCMaterialActStatus = {}));
export var RecurringSubscriptionStatus;
(function (RecurringSubscriptionStatus) {
    RecurringSubscriptionStatus["Active"] = "active";
    RecurringSubscriptionStatus["WaitingForPayment"] = "waitingForPayment";
    RecurringSubscriptionStatus["Cancelled"] = "cancelled";
})(RecurringSubscriptionStatus || (RecurringSubscriptionStatus = {}));
export var RecurringSubscriptionComputedStatus;
(function (RecurringSubscriptionComputedStatus) {
    RecurringSubscriptionComputedStatus["Active"] = "active";
    RecurringSubscriptionComputedStatus["Trial"] = "trial";
    RecurringSubscriptionComputedStatus["Cancelled"] = "cancelled";
})(RecurringSubscriptionComputedStatus || (RecurringSubscriptionComputedStatus = {}));
export var RecurringSubscriptionExtendedStatus;
(function (RecurringSubscriptionExtendedStatus) {
    RecurringSubscriptionExtendedStatus["NotStarted"] = "notStarted";
    RecurringSubscriptionExtendedStatus["Active"] = "active";
    RecurringSubscriptionExtendedStatus["Refunded"] = "refunded";
    RecurringSubscriptionExtendedStatus["Ended"] = "ended";
})(RecurringSubscriptionExtendedStatus || (RecurringSubscriptionExtendedStatus = {}));
export var RecurringSubscriptionRenewPeriod;
(function (RecurringSubscriptionRenewPeriod) {
    RecurringSubscriptionRenewPeriod["Monthly"] = "monthly";
    RecurringSubscriptionRenewPeriod["Annual"] = "annual";
})(RecurringSubscriptionRenewPeriod || (RecurringSubscriptionRenewPeriod = {}));
export var Tabs;
(function (Tabs) {
    Tabs["Subjective"] = "subjective";
    Tabs["Objective"] = "objective";
    Tabs["Assessment"] = "assessmentLikeEpisodes";
    Tabs["Plan"] = "plan";
    Tabs["Billing"] = "billing";
    Tabs["Review"] = "review";
})(Tabs || (Tabs = {}));
export var EntryCheckStatus;
(function (EntryCheckStatus) {
    EntryCheckStatus["Default"] = "default";
    EntryCheckStatus["InProgress"] = "inProgress";
    EntryCheckStatus["Warn"] = "warn";
    EntryCheckStatus["Critical"] = "critical";
    EntryCheckStatus["Good"] = "good";
    EntryCheckStatus["Excellent"] = "excellent";
})(EntryCheckStatus || (EntryCheckStatus = {}));
export var SubscriptionPriceStatus;
(function (SubscriptionPriceStatus) {
    SubscriptionPriceStatus["Active"] = "active";
    SubscriptionPriceStatus["Archived"] = "archived";
})(SubscriptionPriceStatus || (SubscriptionPriceStatus = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Active"] = "active";
    SubscriptionStatus["Archived"] = "archived";
    SubscriptionStatus["Planned"] = "planned";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var ZoomRecordingLocation;
(function (ZoomRecordingLocation) {
    ZoomRecordingLocation["Local"] = "local";
    ZoomRecordingLocation["Cloud"] = "cloud";
    ZoomRecordingLocation["None"] = "none";
})(ZoomRecordingLocation || (ZoomRecordingLocation = {}));
export var SavedPaymentMethodType;
(function (SavedPaymentMethodType) {
    SavedPaymentMethodType["Card"] = "card";
    SavedPaymentMethodType["SBP"] = "sbp";
})(SavedPaymentMethodType || (SavedPaymentMethodType = {}));
export var SavedPaymentMethodStatus;
(function (SavedPaymentMethodStatus) {
    SavedPaymentMethodStatus["Active"] = "active";
    SavedPaymentMethodStatus["Archived"] = "archived";
    SavedPaymentMethodStatus["Pending"] = "pending";
})(SavedPaymentMethodStatus || (SavedPaymentMethodStatus = {}));
export var SharedSavedPaymentMethodStatus;
(function (SharedSavedPaymentMethodStatus) {
    SharedSavedPaymentMethodStatus["Active"] = "active";
    SharedSavedPaymentMethodStatus["Suspended"] = "suspended";
    SharedSavedPaymentMethodStatus["Archived"] = "archived";
})(SharedSavedPaymentMethodStatus || (SharedSavedPaymentMethodStatus = {}));
export var FinancePaymentProvider;
(function (FinancePaymentProvider) {
    FinancePaymentProvider["Yookassa"] = "Yookassa";
    FinancePaymentProvider["Raiffeisen"] = "Raiffeisen";
    FinancePaymentProvider["Arca"] = "Arca";
    FinancePaymentProvider["TBank"] = "TBank";
})(FinancePaymentProvider || (FinancePaymentProvider = {}));
export var RoleName;
(function (RoleName) {
    RoleName["HeadOfClinic"] = "head_of_clinic";
    RoleName["PracticeLeader"] = "practice_leader";
    RoleName["Doctor"] = "doctor";
    RoleName["Assistant"] = "assistant";
    RoleName["Helpdesk"] = "helpdesk";
    RoleName["Developer"] = "developer";
    RoleName["Accountant"] = "accountant";
    RoleName["MedicalDirector"] = "medical_director";
    RoleName["Care"] = "care";
    RoleName["ProcedureNurse"] = "procedure_nurse";
})(RoleName || (RoleName = {}));
export var MostPopularEntityType;
(function (MostPopularEntityType) {
    MostPopularEntityType["MedicalCaseName"] = "medicalCaseName";
})(MostPopularEntityType || (MostPopularEntityType = {}));
export var UserPreferenceType;
(function (UserPreferenceType) {
    UserPreferenceType["ReferralLaboratory"] = "referralLaboratory";
})(UserPreferenceType || (UserPreferenceType = {}));
export var GrantKind;
(function (GrantKind) {
    GrantKind["Create"] = "create";
    GrantKind["Extend"] = "extend";
    GrantKind["Revoke"] = "revoke";
})(GrantKind || (GrantKind = {}));
export var GrantSource;
(function (GrantSource) {
    GrantSource["Reservation"] = "reservation";
    GrantSource["Referral"] = "referral";
    GrantSource["Episode"] = "episode";
    GrantSource["Entry"] = "entry";
    GrantSource["Task"] = "task";
    GrantSource["Recommendation"] = "recommendation";
    GrantSource["RecurringSubscription"] = "recurring_subscription";
    GrantSource["Self"] = "self";
})(GrantSource || (GrantSource = {}));
export var RevokeReason;
(function (RevokeReason) {
    RevokeReason["SourceArchived"] = "source_archived";
    RevokeReason["SourceDeleted"] = "source_deleted";
    RevokeReason["SourceClosed"] = "source_closed";
    RevokeReason["SourceCompleted"] = "source_completed";
    RevokeReason["TtlExpired"] = "ttl_expired";
    RevokeReason["Blacklisted"] = "blacklisted";
    RevokeReason["Manual"] = "manual";
})(RevokeReason || (RevokeReason = {}));
export var EhrAccessMemberStatus;
(function (EhrAccessMemberStatus) {
    EhrAccessMemberStatus["Active"] = "active";
    EhrAccessMemberStatus["Expired"] = "expired";
    EhrAccessMemberStatus["Blocked"] = "blocked";
})(EhrAccessMemberStatus || (EhrAccessMemberStatus = {}));
export var EhrAccessGrantSortingField;
(function (EhrAccessGrantSortingField) {
    EhrAccessGrantSortingField["GrantedAt"] = "grantedAt";
})(EhrAccessGrantSortingField || (EhrAccessGrantSortingField = {}));
export var EhrAccessBlacklistSortingField;
(function (EhrAccessBlacklistSortingField) {
    EhrAccessBlacklistSortingField["BlockedAt"] = "blockedAt";
})(EhrAccessBlacklistSortingField || (EhrAccessBlacklistSortingField = {}));
export var EntrySoapGroup;
(function (EntrySoapGroup) {
    EntrySoapGroup["Subjective"] = "subjective";
    EntrySoapGroup["Objective"] = "objective";
    EntrySoapGroup["Assessment"] = "assessment";
    EntrySoapGroup["Plan"] = "plan";
    EntrySoapGroup["Payment"] = "payment";
})(EntrySoapGroup || (EntrySoapGroup = {}));
// Значения совпадают с HTTP-полем `code` доменных ошибок расписания
// (имя класса минус суффикс Error); фронт матчит по ним `error.name`.
export var ScheduleRuleErrorCode;
(function (ScheduleRuleErrorCode) {
    ScheduleRuleErrorCode["OfficeOccupied"] = "ScheduleRuleOfficeOccupied";
    ScheduleRuleErrorCode["UserOccupied"] = "ScheduleRuleUserOccupied";
    ScheduleRuleErrorCode["HasActiveReservations"] = "ScheduleRuleHasActiveReservations";
    ScheduleRuleErrorCode["AssistantPracticeMismatch"] = "ScheduleRuleAssistantPracticeMismatch";
    ScheduleRuleErrorCode["MultipleOffices"] = "ScheduleRuleMultipleOffices";
    ScheduleRuleErrorCode["BatchConflict"] = "ScheduleRuleBatchConflict";
})(ScheduleRuleErrorCode || (ScheduleRuleErrorCode = {}));
export var ReservationErrorCode;
(function (ReservationErrorCode) {
    ReservationErrorCode["HasIntersection"] = "ReservationHasIntersection";
    ReservationErrorCode["AgeForbidden"] = "AgeForbidden";
})(ReservationErrorCode || (ReservationErrorCode = {}));
export var TimeBlockRuleErrorCode;
(function (TimeBlockRuleErrorCode) {
    TimeBlockRuleErrorCode["Conflict"] = "TimeBlockRuleConflict";
})(TimeBlockRuleErrorCode || (TimeBlockRuleErrorCode = {}));
export var DeviceReservationType;
(function (DeviceReservationType) {
    DeviceReservationType["Booking"] = "booking";
    DeviceReservationType["OccupiedTime"] = "occupied_time";
})(DeviceReservationType || (DeviceReservationType = {}));
export var DeviceReservationStatus;
(function (DeviceReservationStatus) {
    DeviceReservationStatus["Reserved"] = "reserved";
    DeviceReservationStatus["Cancelled"] = "cancelled";
})(DeviceReservationStatus || (DeviceReservationStatus = {}));
export var DeviceOccupancyErrorCode;
(function (DeviceOccupancyErrorCode) {
    DeviceOccupancyErrorCode["Conflict"] = "DeviceOccupancyConflict";
})(DeviceOccupancyErrorCode || (DeviceOccupancyErrorCode = {}));
export var EntryArchiveExportStatus;
(function (EntryArchiveExportStatus) {
    EntryArchiveExportStatus["InProgress"] = "inProgress";
    EntryArchiveExportStatus["Completed"] = "completed";
    EntryArchiveExportStatus["Failed"] = "failed";
})(EntryArchiveExportStatus || (EntryArchiveExportStatus = {}));
export var DrugSearchEntryKind;
(function (DrugSearchEntryKind) {
    DrugSearchEntryKind["Substance"] = "substance";
    DrugSearchEntryKind["Trade"] = "trade";
})(DrugSearchEntryKind || (DrugSearchEntryKind = {}));
export var NsiDictionaryName;
(function (NsiDictionaryName) {
    NsiDictionaryName["DoctorPosition"] = "doctorPosition";
    NsiDictionaryName["FrmrPosition"] = "frmrPosition";
    NsiDictionaryName["RemdRole"] = "remdRole";
    NsiDictionaryName["Region"] = "region";
})(NsiDictionaryName || (NsiDictionaryName = {}));
